import { render } from "./ConfirmEmailInvite.vue?vue&type=template&id=70a8c8e3&scoped=true"
import script from "./ConfirmEmailInvite.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailInvite.vue?vue&type=script&lang=js"

import "./custom-confirm-email.scss?vue&type=style&index=0&id=70a8c8e3&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a8c8e3"]])

export default __exports__